import type { InputHTMLAttributes } from "react";
import { cn } from "@/shared/lib/cn";

/** 基础输入框 */
export function Input({
  className,
  ...props
}: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      className={cn(
        "h-8 w-full rounded-[var(--radius-sm)] border border-border bg-bg-card px-3 text-[13px] text-fg placeholder:text-fg-subtle outline-none transition-[border,box-shadow] duration-[var(--dur)] focus:border-brand/50 focus:ring-2 focus:ring-brand/30",
        className,
      )}
      {...props}
    />
  );
}
